const Data = {
  categories: [
    {
      restaurant_category_id: "4171",
      restaurant_category_identity: "CAT4171",
      restaurant_category_name: "Main Meals",
      ordering_rank: "1",
    },
    {
      restaurant_category_id: "4147",
      restaurant_category_identity: "CAT4147",
      restaurant_category_name: "Main Meals",
      ordering_rank: "2",
    },
    {
      restaurant_category_id: "4172",
      restaurant_category_identity: "CAT4172",
      restaurant_category_name: "Sea Food",
      ordering_rank: "2",
    },
    {
      restaurant_category_id: "4173",
      restaurant_category_identity: "CAT4173",
      restaurant_category_name: "Hot Drinks & Juices",
      ordering_rank: "2",
    },
    {
      restaurant_category_id: "4203",
      restaurant_category_identity: "CAT4203",
      restaurant_category_name: "salad",
      ordering_rank: "2",
    },
    {
      restaurant_category_id: "4174",
      restaurant_category_identity: "CAT4174",
      restaurant_category_name: "Juices",
      ordering_rank: "4",
    },
   ],
  items: [
    {
      restaurant_category_id: "4171",
      restaurant_category_name: "Main Meals",
      item_id: "23164",
      item_identity: "ITEM23164",
      item_name: "Main Meal Mini Pack",
      item_description: "Item # Desc",
      item_image: "164742537014.png",
      image_url:
        "https://zemaas-qa-static-content.s3.ca-central-1.amazonaws.com/images/uploads/164742537014.png",
      image_thumbnail_url:
        "https://zemaas-qa-static-content.s3.ca-central-1.amazonaws.com/images/uploads/thumbnail/164742537014.png",
      item_status: 1,
      item_size_type: 0,
      item_quantity: 0,
      item_customizable: 0,
      item_price: "INR 45.00",
      item_price_old: "",
      item_size: [],
      item_amount: "45.00",
      item_add_on: "",
      order_before: 0,
      populer_item: 0,
    },
    {
      restaurant_category_id: "4174",
      restaurant_category_name: "Juices",
      item_id: "23183",
      item_identity: "ITEM23183",
      item_name: "Orange Juice",
      item_description: "",
      item_image: "",
      image_url: "",
      image_thumbnail_url: "",
      item_status: 1,
      item_size_type: 0,
      item_quantity: 0,
      item_customizable: 0,
      item_price: "INR 25.00",
      item_price_old: "",
      item_size: [],
      item_amount: "25.00",
      item_add_on: "",
      order_before: 0,
      populer_item: 0,
    },
    {
      restaurant_category_id: "4173",
      restaurant_category_name: "Hot Drinks & Juices",
      item_id: "23203",
      item_identity: "ITEM23203",
      item_name: "Hot Soup",
      item_description: "",
      item_image: "16474249576.jpg",
      image_url:
        "https://zemaas-qa-static-content.s3.ca-central-1.amazonaws.com/images/uploads/16474249576.jpg",
      image_thumbnail_url:
        "https://zemaas-qa-static-content.s3.ca-central-1.amazonaws.com/images/uploads/thumbnail/16474249576.jpg",
      item_status: 0,
      item_size_type: 0,
      item_quantity: 0,
      item_customizable: 1,
      item_price: "INR 60.00",
      item_price_old: "",
      item_size: [],
      item_amount: "60.00",
      item_add_on: "11141",
      order_before: 0,
      populer_item: 0,
    },
    {
      restaurant_category_id: "4172",
      restaurant_category_name: "Sea Food",
      item_id: "23208",
      item_identity: "ITEM23208",
      item_name: "Sea Food Pack",
      item_description: "",
      item_image: "16474248267.png",
      image_url:
        "https://zemaas-qa-static-content.s3.ca-central-1.amazonaws.com/images/uploads/16474248267.png",
      image_thumbnail_url:
        "https://zemaas-qa-static-content.s3.ca-central-1.amazonaws.com/images/uploads/thumbnail/16474248267.png",
      item_status: 2,
      item_size_type: 0,
      item_quantity: 0,
      item_customizable: 1,
      item_price: "INR 50.00",
      item_price_old: "",
      item_size: [],
      item_amount: "50.00",
      item_add_on: "11143",
      order_before: 0,
      populer_item: 0,
    },
    {
      restaurant_category_id: "4171",
      restaurant_category_name: "Main Meals",
      item_id: "23210",
      item_identity: "ITEM23210",
      item_name: "Main Meal Pack",
      item_description: "Jzjs",
      item_image: "164742478814.png",
      image_url:
        "https://zemaas-qa-static-content.s3.ca-central-1.amazonaws.com/images/uploads/164742478814.png",
      image_thumbnail_url:
        "https://zemaas-qa-static-content.s3.ca-central-1.amazonaws.com/images/uploads/thumbnail/164742478814.png",
      item_status: 1,
      item_size_type: 1,
      item_quantity: 0,
      item_customizable: 1,
      item_price: "INR 42.00",
      item_price_old: "",
      item_size: [
        {
          size_name: "Medium AR",
          item_size_price: "42.00",
        },
      ],
      item_amount: "42.00",
      item_add_on: "",
      order_before: 0,
      populer_item: 0,
    },
    {
      restaurant_category_id: "4147",
      restaurant_category_name: "Main Meals",
      item_id: "23211",
      item_identity: "ITEM23211",
      item_name: "Meal Pack Mini",
      item_description: "",
      item_image: "164725384215.jpg",
      image_url:
        "https://zemaas-qa-static-content.s3.ca-central-1.amazonaws.com/images/uploads/164725384215.jpg",
      image_thumbnail_url:
        "https://zemaas-qa-static-content.s3.ca-central-1.amazonaws.com/images/uploads/thumbnail/164725384215.jpg",
      item_status: 0,
      item_size_type: 1,
      item_quantity: 0,
      item_customizable: 1,
      item_price: "INR 45.00",
      item_price_old: "",
      item_size: [
        {
          size_name: "Small",
          item_size_price: "45.00",
        },
      ],
      item_amount: "45.00",
      item_add_on: "",
      order_before: 0,
      populer_item: 0,
    },
    {
      restaurant_category_id: "4147",
      restaurant_category_name: "Main Meals",
      item_id: "23212",
      item_identity: "ITEM23212",
      item_name: "Main Meal Pack Jumbo",
      item_description: "",
      item_image: "16474239319.png",
      image_url:
        "https://zemaas-qa-static-content.s3.ca-central-1.amazonaws.com/images/uploads/16474239319.png",
      image_thumbnail_url:
        "https://zemaas-qa-static-content.s3.ca-central-1.amazonaws.com/images/uploads/thumbnail/16474239319.png",
      item_status: 0,
      item_size_type: 1,
      item_quantity: 0,
      item_customizable: 1,
      item_price: "INR 100.00",
      item_price_old: "",
      item_size: [
        {
          size_name: "Medium AR",
          item_size_price: "100.00",
        },
      ],
      item_amount: "100.00",
      item_add_on: "",
      order_before: 0,
      populer_item: 0,
    },
    {
      restaurant_category_id: "4174",
      restaurant_category_name: "Juices",
      item_id: "23222",
      item_identity: "ITEM23222",
      item_name: "Mango Juice",
      item_description: "",
      item_image: "",
      image_url: "",
      image_thumbnail_url: "",
      item_status: 1,
      item_size_type: 0,
      item_quantity: 0,
      item_customizable: 0,
      item_price: "INR 50.00",
      item_price_old: "",
      item_size: [],
      item_amount: "50.00",
      item_add_on: "",
      order_before: 0,
      populer_item: 0,
    },
    {
      restaurant_category_id: "4174",
      restaurant_category_name: "Juices",
      item_id: "23221",
      item_identity: "ITEM23221",
      item_name: "Pineapple Juice",
      item_description: "",
      item_image: "",
      image_url: "",
      image_thumbnail_url: "",
      item_status: 1,
      item_size_type: 0,
      item_quantity: 0,
      item_customizable: 0,
      item_price: "INR 30.00",
      item_price_old: "",
      item_size: [],
      item_amount: "30.00",
      item_add_on: "",
      order_before: 0,
      populer_item: 0,
    },
    {
      restaurant_category_id: "4173",
      restaurant_category_name: "Hot Drinks & Juices",
      item_id: "23223",
      item_identity: "ITEM23223",
      item_name: "Apple Juice",
      item_description: "",
      item_image: "",
      image_url: "",
      image_thumbnail_url: "",
      item_status: 1,
      item_size_type: 1,
      item_quantity: 0,
      item_customizable: 1,
      item_price: "INR 99.00",
      item_price_old: "",
      item_size: [
        {
          size_name: "Large",
          item_size_price: "99.00",
        },
      ],
      item_amount: "99.00",
      item_add_on: "",
      order_before: 0,
      populer_item: 1,
    },
    {
      restaurant_category_id: "4173",
      restaurant_category_name: "Hot Drinks & Juices",
      item_id: "23224",
      item_identity: "ITEM23224",
      item_name: "Mango Juice",
      item_description: "",
      item_image: "",
      image_url: "",
      image_thumbnail_url: "",
      item_status: 1,
      item_size_type: 0,
      item_quantity: 0,
      item_customizable: 1,
      item_price: "INR 50.00",
      item_price_old: "",
      item_size: [],
      item_amount: "50.00",
      item_add_on: "11157",
      order_before: 0,
      populer_item: 0,
    },
    {
      restaurant_category_id: "4147",
      restaurant_category_name: "Main Meals",
      item_id: "23228",
      item_identity: "ITEM23228",
      item_name: "pizza",
      item_description: "Test pizza",
      item_image: "",
      image_url: "",
      image_thumbnail_url: "",
      item_status: 1,
      item_size_type: 1,
      item_quantity: 0,
      item_customizable: 1,
      item_price: "INR 50.00",
      item_price_old: "",
      item_size: [
        {
          size_name: "Large",
          item_size_price: "50.00",
        },
      ],
      item_amount: "50.00",
      item_add_on: "11153",
      order_before: 0,
      populer_item: 0,
    },
  ],
};

export default Data;
